import { RocheUIHighlightBox } from '@repo/roche-ui';
import React, { FC, useEffect, useRef } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { blokToComponent } from '../../helpers/blok-to-component';

type RocheHighlightBoxProps = BlokToComponentProps<{
  color: string;
  slotted: any[];
}>;

export const RocheHighlightBox: FC<RocheHighlightBoxProps> = ({ blok, slot, getComponent }) => {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // used until side by side is refactored: reverts margins
    const rocheSideBySide = elementRef.current?.querySelector('roche-side-by-side') as unknown as HTMLElement;
    if (rocheSideBySide) {
      rocheSideBySide.style.margin = '0px';
    }
    // used until headline is refactored: reverts margins
    const rocheHeadline = elementRef.current?.querySelector('roche-headline') as unknown as HTMLElement;
    if (rocheHeadline) {
      rocheHeadline.style.marginTop = '0px';
    }
    // used until button is refactored: reverts margins

    const rocheButton = elementRef.current?.querySelector('roche-button') as unknown as HTMLElement;
    if (rocheButton && !rocheButton.closest('roche-side-by-side')) {
      rocheButton.style.marginTop = '0px';
    }
  }, []);

  return (
    <div ref={elementRef} slot={slot}>
      <RocheUIHighlightBox color={blok.color}>
        {blok.slotted?.map((item) => blokToComponent({ getComponent, blok: item }, 'highlight-box'))}
      </RocheUIHighlightBox>
    </div>
  );
};
